import { Button, Grid, Stack } from '@mantine/core';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import InputField, { InputFieldTypes } from '../components/input_field';
import { JobsCalendar } from '../components/jobs_calendar';
import { useApp } from '../contexts/app.context';
import { useAuth } from '../contexts/auth.context';
import { useQuery } from '../utility/util';

export default function CalendarPage() {
    const [openDone, setOpenDone] = React.useState(false);
    const [period, setPeriod] = React.useState([null, null]);

    const query = useQuery();
    const customerId = query.get("cliente");
    const agentId = query.get("responsavel");

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { confirmDialog, customers, configs, agents } = useApp();
    const { role } = useAuth();
    const viewType = query.get("present");


    return <Stack spacing={0}>
        {/* <Title order={3} color={configs?.contrast}>Jobs</Title> */}
        <Grid align='flex-end' justify='flex-end'>
            {role && <Grid.Col md={2}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    value={agentId}
                    name={"agent"}
                    size="md"
                    placeholder="Responsável"
                    options={agents.map(a => ({ label: a.name, value: a._id }))}
                    onChange={({ agent }) => {
                        if (["null", null, undefined].includes(agent) || agentId === agent) {
                            searchParams.delete("responsavel");
                            setSearchParams(searchParams);
                        } else {
                            searchParams.set("responsavel", agent);
                            setSearchParams(searchParams);
                        }
                    }}
                />
            </Grid.Col>}
            {role && <Grid.Col md={2}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    value={customerId}
                    name={"customer"}
                    size="md"
                    placeholder="Cliente"
                    options={customers.filter(c => c.active).map(a => ({ label: a.name, value: a._id }))}
                    onChange={({ customer }) => {
                        if (["null", null, undefined].includes(customer) || customerId === customer) {
                            searchParams.delete("cliente");
                            setSearchParams(searchParams);
                        } else {
                            searchParams.set("cliente", customer);
                            setSearchParams(searchParams);
                        }
                    }}
                />
            </Grid.Col>}

            <Grid.Col md={2}>
                <Button
                    fullWidth
                    size="md"
                    leftIcon={<FaPlus />}
                    onClick={() => { navigate(role ? "/jobs/novo" : "/solicitar") }}
                >Job</Button>
            </Grid.Col>
            {/* <Tooltip label="Alterar Visualização">
                        <ActionIcon
                            size="xl"
                            variant="light"
                            color='gray'
                            onClick={() => {
                                searchParams.set("present", viewType === "calendar" ? "kanbam" : "calendar");
                                setSearchParams(searchParams);
                            }}
                        >
                            {viewType === "calendar" ? <FaCalendar /> : <FaPause />}
                        </ActionIcon>
                    </Tooltip> */}
            <Grid.Col md={12}>
                <JobsCalendar customerId={customerId} agentId={agentId} />
            </Grid.Col>

            {/* <Table
            columns={[
                { title: "Cliente", key: "customer", render: item => <CustomerAvatar name={item?.customer?.name} /> },
                { title: "Nome do JOB", key: "name" },
                { title: "Itens", key: "tasks", render: item => (item.tasks || []).map(t => <div>{t.name}</div>) },
                { title: "Última atualização", key: "last_update", render: item => moment(item.last_update).format("DD/MM/YYYY HH:mm:ss") },
                { title: "Status", key: "status", render: item => <Badge color={item.statusCategory === "done" ? "green" : item.statusCategory === "pendent" ? "gray" : "blue"}>{item.status}</Badge> },
            ]}
            actions={[
                {
                    title: "Editar",
                    color: "blue",
                    onClick: ({item}) => {
                        navigate(role ? `/jobs/${item.id}` : `/j/${item.id}`)
                    }
                },
                {
                    title: "Deletar",
                    color: 'red',
                    onClick: ({item}) => {
                        app.confirmDialog(
                            {text: "Realmente deseja deletar?"},
                            (({confirmed}) => {
                                if(confirmed) deleteItem(item.id);
                            })
                        )
                    }
                },
            ]}
            data={items}
        /> */}
        </Grid>
        {/* 
        <Modal
            opened={openDone}
            onClose={() => { setOpenDone(false) }}
            size="sm"
        >
            {getItems(null, true).map(renderItem)}
        </Modal> */}
    </Stack >
}